import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Button } from "reactstrap";

import { withRouter, Link, useHistory } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "assets/images/logo-large.png";

import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequestsWOAccessToken from '../../Utils/useRequestsWOAccessToken';
import i18next from 'i18next';


const ForgotPasswordPage = props => {
  //meta title
  document.title = i18next.t('Forgot_Password PG document title');
  const history = useHistory();
  const { getRequestWOAccessToken, postRequestWOAccessToken } = useRequestsWOAccessToken();


  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(i18next.t('Please enter a valid email!'))
        .max(255)
        .required(i18next.t('Forgot_Password PG Email is required')),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = i18next.t('Processing...');

        const jsonpar = JSON.stringify({
          email: values.email
        });
        const res = await postRequestWOAccessToken('forgot-password', jsonpar);
        if (res && res.code === 200) {
          let originalText = res.data;

          history.push('/change-password', { id: originalText, email: values.email, code: 200, status: 'success', message: res.message });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = i18next.t('Submit');
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}

      <div className="p-0 container-fluid">
        <Row className="g-0">
          <Col className="LeftImg">
            <div className="auth-full-page-content p-4 bg-white">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="auth-logo-light">
                      <div className="mb-1">
                        <span className=""> <img src={logo} alt="" height="60" /> </span>
                      </div>
                    </Link>
                  </div>
                  <div className="my-auto">
                    <div>
                      <h5 className="text-black">{i18next.t('Forgot_Password PG Forgot your password')} ?</h5>
                    </div>
                    <div className="mt-4">
                      <Form>
                        <div className="mb-3">
                          <Label className="form-label">{i18next.t('Forgot_Password PG Email')} :</Label>
                          <Input
                            name="email"
                            type="email"
                            placeholder={i18next.t('Forgot_Password PG Enter email')}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.email || ""}
                            invalid={
                              validation1.touched.email && validation1.errors.email ? true : false
                            }
                          />
                          {validation1.touched.email && validation1.errors.email ? (
                            <FormFeedback type="invalid">{validation1.errors.email}</FormFeedback>
                          ) : null}
                        </div>
                        <Row className="mb-3">
                          <Col className="text-end">
                            <Button
                              id="submit1"
                              onClick={(e) => {
                                e.preventDefault();
                                validation1.handleSubmit();
                                return false;
                              }}
                              className="btn btn-primary btn-block fullWidth"> {i18next.t('Submit')} </Button>
                          </Col>
                        </Row>
                      </Form>
                      <div className="mt-3 text-center">
                        <p className="footer-text-color">
                          {i18next.t('Forgot_Password PG Go back to')}{" "}
                          <Link to="login" className="font-weight-medium text-underline">
                            {i18next.t('Login')}
                          </Link>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="footer-text-color"> © {new Date().getFullYear()} Tokenizedgreen.</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="rightImg">
            <div className="bgLogin"></div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

ForgotPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgotPasswordPage);
